module.exports = __webpack_public_path__ + "img/filete_apanado.be316fb0.jpg";